import { render, staticRenderFns } from "./card-form-spelling.vue?vue&type=template&id=1e00616f&scoped=true&"
import script from "./card-form-spelling.vue?vue&type=script&lang=js&"
export * from "./card-form-spelling.vue?vue&type=script&lang=js&"
import style0 from "./card-form-spelling.vue?vue&type=style&index=0&id=1e00616f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e00616f",
  null
  
)

export default component.exports